/**
 * The 2FA endpoints answer with a stable machine-readable `code` beside
 * the localized `message`, and TWO_FA_LOCKED carries
 * `retryAfterMinutes` as a number. Branch on `code`, never on
 * `message` — the message is translated.
 */
export interface ApiError {
  status: number;
  message: string;
  code?: string;
  retryAfterMinutes?: number;
}

const DEFAULT_MESSAGE = 'Something went wrong';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const readApiError = (err: any): ApiError => {
  const body = err?.response?.data;
  const message = Array.isArray(body?.message)
    ? body.message.filter(Boolean).join(', ')
    : body?.message || err?.message || DEFAULT_MESSAGE;

  return {
    status: err?.response?.status ?? body?.statusCode ?? 0,
    message: message || DEFAULT_MESSAGE,
    ...(typeof body?.code === 'string' ? { code: body.code } : {}),
    ...(typeof body?.retryAfterMinutes === 'number'
      ? { retryAfterMinutes: body.retryAfterMinutes }
      : {})
  };
};
